<template>
  <div :id="`modal-${modalId}`">
    <MadModal
      :id="modalId"
      :data-cy="`${modalId}-modal`"
      @opened="onOpened"
      @closed="onClosed"
    >
      <div class="modal-body">
        <div class="card card-default">
          <div class="card-header">
            <h5>{{ $t('JSON.what-would-you-like-to-do') }}</h5>
          </div>

          <div class="card-body">
            <div
              v-for="(modal, key) in modals"
              :key="key"
            >
              <b-button
                variant="primary"
                @click="toggleModal(`${key}`)"
              >
                {{ _.startCase(_.camelCase(modal.text)) }}
                <b-badge variant="light">
                  {{ modal.shortcut }}
                </b-badge>
              </b-button>
              <br><br>
            </div>
          </div>
        </div>
      </div>
    </MadModal>
  </div>
</template>

<script>
/* eslint-disable consistent-return */

import Keypress from 'keypress.js';
import permissions from '@/mixins/permissions';

export default {

  components: {
    MadModal: () => import('@/components/MadModal'),
  },
  mixins: [permissions],

  data() {
    return {
      opened: false,
      listener: null,
      timeout: null,
    };
  },

  computed: {
    modalId() {
      return 'spawner';
    },

    _() {
      return _;
    },

    modals() {
      return {
        site: {
          text: this.$i18n.t('JSON.manage-websites'),
          shortcut: 'w',
        },
        server: {
          text: this.$i18n.t('JSON.manage-servers'),
          shortcut: 's',
        },
        deployment: {
          text: this.$i18n.t('JSON.manage-deployments'),
          shortcut: 'd',
        },
        domain: {
          text: this.$i18n.t('JSON.manage-domains'),
          shortcut: 'o',
        },
        domaintld: {
          text: this.$i18n.t('JSON.manage-domain-tlds'),
          shortcut: 'l',
        },
        template: {
          text: this.$i18n.t('JSON.manage-templates'),
          shortcut: 't',
        },
        repository: {
          text: this.$i18n.t('JSON.manage-repositories'),
          shortcut: 'r',
        },
      };
    },
  },

  created() {
    this.setupKeyboardListeners();
  },

  beforeDestroy() {
    this.listener.reset();
  },

  methods: {
    toggleModal(modalId) {
      // console.log(`toggling modal ${modalId}`);
      if (this.isLoggedIn()) {
        Bus.$emit('toggle_modal', modalId, null);
      }
    },

    onOpened() {
      this.opened = true;
    },

    onClosed() {
      this.opened = false;
    },

    setupKeyboardListeners() {
      this.listener = new Keypress.Listener();

      // console.log(this.modals);

      Object.keys(this.modals).forEach((key) => {
        // console.log(key, this.modals[key]);

        this.listener.simple_combo(this.modals[key].shortcut, (event) => {
          // console.log(`pressed ${this.modals[key].shortcut}`);
          if ((event.target.tagName === 'INPUT' || event.target.tagName === 'TEXTAREA') || !this.opened) {
            return true;
          }

          this.toggleModal(key);
        });
      });
    },
  },
};
</script>
